import { Inject, Injectable } from '@angular/core';
import { CrudFluxService } from 'src/app/core/services/crud-flux.service';
import { QueryService } from 'src/app/core/services/query.service';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import { ARERA_ENDPOINT, ARERA_QUERY_SERVICE_INSTANCE } from '../arera.config';
import { ApiService } from 'src/app/core/services/api.service';
import { CrudService } from 'src/app/core/services/crud.service';

@Injectable({
  providedIn: 'root'
})
export class AreraService extends CrudService<any> {

   constructor(
      @Inject(ARERA_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<any>,
      public readonly apiService: ApiService,
      protected  override readonly snackbar : SnackbarService
    ) {
  
      super(ARERA_ENDPOINT, apiService, snackbar);
    }

    switchWaterSupplyCompany(id: number) {
      return this.apiService.post(ARERA_ENDPOINT + `/gestore-servizi-idrici/switch/${id}`, {});
    }
}
